import styled from 'styled-components';

export const ModalTitle = styled.h4`
color: #083F44;
font-family: "Jost", sans-serif;
font-size:20px;
font-weight: 600;
line-height: 30px;
text-align: center;
margin-top: 30px;
margin-bottom:20px;
 
`;
export const ModalButton = styled.div`
    display: flex;
    gap:30px;
    justify-content: center;
`;
